import { useCallback } from 'react';

import type { WindowWithZendesk } from 'utils/types';

export const useErrorStepService = () => {
  const handleSupport = useCallback(() => {
    const { zE } = window as WindowWithZendesk;

    if (zE) zE('messenger', 'open');
  }, []);

  return { handleSupport };
};
